// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let PortfolioStatisticsRequest = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_PORTFOLIO_STATISTICS_REQUEST;
    PFixMessage.call(this, fieldSet);
}
PortfolioStatisticsRequest.prototype = Object.create(PFixMessage.prototype);

PortfolioStatisticsRequest.prototype.setAccountId = function (accountId)
{
    this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
}

PortfolioStatisticsRequest.prototype.setType = function (type)
{
    this.setFieldValue(FieldsFactory.FIELD_TYPE, type);
}

PortfolioStatisticsRequest.prototype.setStartTime = function (startTime)
{
    if (startTime)
        this.setFieldValue(FieldsFactory.FIELD_START_TIME, startTime);
}

PortfolioStatisticsRequest.prototype.setEndTime = function (endTime)
{
    if (endTime)
        this.setFieldValue(FieldsFactory.FIELD_END_TIME, endTime);
}

PortfolioStatisticsRequest.prototype.setRouteId = function (routeId)
{
    if (routeId)
        this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId);
}

PortfolioStatisticsRequest.prototype.setInstrumentTradableId = function (instrumentTradableId)
{
    if (instrumentTradableId)
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrumentTradableId);
}